import { render, staticRenderFns } from "./LayerLegendComponent.vue?vue&type=template&id=32434dce&scoped=true&"
import script from "./LayerLegendComponent.vue?vue&type=script&lang=js&"
export * from "./LayerLegendComponent.vue?vue&type=script&lang=js&"
import style0 from "./LayerLegendComponent.vue?vue&type=style&index=0&id=32434dce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32434dce",
  null
  
)

export default component.exports